export default {
  Dashboard: {
    Chart: {
      User: {
        Title: 'آمار کاربران',
        Footer: ' آمار تعداد کاربران ثبت نامی',
        Today: 'امروز',
        Yesterday: 'دیروز',
        OneWeekAgo: 'یک هفته گذشته',
        OneMonthAgo: 'یک ماه گذشته',
        ThreeMonthAgo: 'سه ماه گذشته',
        SixMonthAgo: 'شش ماه گذشته',
      },
      Payment: {
        Title: 'تراکنش های مالی',
        Footer: 'آمار تراکنش های موفق و ناموفق',
      },
    },
    Developer: {
      Title: 'لیست توسعه‌دهندگان در انتظار تایید',
      NotFound: 'توسعه‌دهندگان در انتظار تاییدی وجود ندارد.',
      Table: {
        User: 'توسعه‌دهنده',
      },
    },
    Ticket: {
      Title: 'لیست تیکت‌های در انتظار پاسخ',
      NotFound: 'تیکت در انتظار پاسخی وجود ندارد.',
      Table: {
        Number: 'شماره تیکت',
        User: 'کاربر',
      },
    },
    Comment: {
      Title: 'لیست نظرات در انتظار تایید',
      NotFound: 'نظر در انتظار تاییدی وجود ندارد.',
      Table: {
        Application: 'برنامه',
        User: 'کاربر',
      },
    },
    App: {
      Title: 'آمار برنامه ها',
      Count: 'آمار تعداد برنامه های دانلود شده',
      Table: {
        Title: 'لیست اپلیکیشن های در حال برسی',
        NotFound: 'اپلیکیشنی در حال برسی وجود ندارد',
        Application: 'برنامه',
        User: 'کاربر',
      },
    },
    Card: {
      Title: 'لیست کارت های در انتظار تایید',
      Num: 'شماره کارت',
    },
    CrashReport: {
      Title: 'لیست گزارش اشکال برنامه‌ها',
      NotFound: 'گزارشی اشکالی وجود ندارد.',
      Table: {
        Type: 'نوع',
        Application: 'برنامه',
        User: 'کاربر',
      },
    },
  },
}
